import { Box, Modal, Stack, ThemeProvider, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { storeElement } from 'GlobalStores/StoreElement'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import { ReactComponent as WarningIcon } from '../Assets/Svgs/warning.svg'
import ReCaptcha from './ReCaptcha'

const style = {
    width: '100%',
    maxWidth: '540px',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    top: '50%',
    left: '50%',
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}

/**
 * v2 challenge shown only when reCAPTCHA v3 does not pass.
 * `disableEnforceFocus` / `disableAutoFocus` are required: Google's challenge iframe lives
 * outside the modal DOM, and MUI's focus trap would pull focus back out of it.
 */
const ModalReCaptchaV2 = observer(({ open, onClose, onVerified, hint }) => {
    return (
        <ThemeProvider theme={storeElement.theme}>
            <Modal open={open} onClose={onClose} disableEnforceFocus disableAutoFocus data-testid="recaptcha-v2-modal">
                <Box sx={style}>
                    <Stack
                        sx={{
                            width: 'auto',
                            background: '#FFFFFF',
                            borderRadius: '8px',
                            padding: '40px 24px',
                            margin: '15px',
                            alignItems: 'center',
                            '@media (min-width: 768px)': {
                                padding: '40px 70px'
                            }
                        }}>
                        <WarningIcon />
                        <Typography
                            mt="40px"
                            sx={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#003B6F',
                                textAlign: 'center',
                                fontFamily: 'Poppins, NotoSansThai',
                                lineHeight: '25px'
                            }}>
                            <T>Oops</T>
                        </Typography>

                        <Typography
                            mt="24px"
                            variant="caption"
                            sx={{
                                fontSize: '16px',
                                color: '#8A9BB0',
                                fontWeight: 400,
                                lineHeight: '20px',
                                textAlign: 'center'
                            }}>
                            <T>desc_modal_recaptchaV2</T>
                        </Typography>

                        {/* The description explains why the modal is here; this line says what to do about it. */}
                        {hint && (
                            <Typography
                                mt="16px"
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    color: '#003B6F',
                                    lineHeight: '20px',
                                    textAlign: 'center'
                                }}>
                                {hint}
                            </Typography>
                        )}

                        <Stack mt="40px">
                            <ReCaptcha handleReCaptCha={verified => verified && onVerified()} />
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </ThemeProvider>
    )
})

export default ModalReCaptchaV2
